import { render, staticRenderFns } from "./OrderableCustomShippingDialog.vue?vue&type=template&id=05fb01f8&"
import script from "./OrderableCustomShippingDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderableCustomShippingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports